import { Button, Col, Form, Row } from "react-bootstrap";

export function DynamicObjectSection({ label, data, setData, keyName }) {
  const handleChange = (field, value) => {
    setData((prev) => ({
      ...prev,
      [keyName]: { ...prev[keyName], [field]: value },
    }));
  };

  const handleSectionChange = (sectionKey, field, value) => {
    setData((prev) => ({
      ...prev,
      [keyName]: {
        ...prev[keyName],
        [sectionKey]: { ...prev[keyName][sectionKey], [field]: value },
      },
    }));
  };

  const handleValueChange = (sectionKey, valIndex, value) => {
    const section = data[sectionKey];
    const newValues = [...section.values];
    newValues[valIndex] = value;

    setData((prev) => ({
      ...prev,
      [keyName]: {
        ...prev[keyName],
        [sectionKey]: { ...section, values: newValues },
      },
    }));
  };

  const addValue = (sectionKey) => {
    const section = data[sectionKey];
    setData((prev) => ({
      ...prev,
      [keyName]: {
        ...prev[keyName],
        [sectionKey]: {
          ...section,
          values: [...section.values, ""],
        },
      },
    }));
  };

  const deleteValue = (sectionKey, valIndex) => {
    const section = data[sectionKey];
    const newValues = section.values.filter((_, idx) => idx !== valIndex);

    setData((prev) => ({
      ...prev,
      [keyName]: {
        ...prev[keyName],
        [sectionKey]: { ...section, values: newValues },
      },
    }));
  };

  const deleteSection = (sectionKey) => {
    setData((prev) => {
      const newData = { ...prev[keyName] };
      delete newData[sectionKey];
      return {
        ...prev,
        [keyName]: newData,
      };
    });
  };

  const addSection = () => {
    const keys = Object.keys(data).filter((k) => k !== "description");
    const nextKey = String(keys.length + 1);
    setData((prev) => ({
      ...prev,
      [keyName]: {
        ...prev[keyName],
        [nextKey]: { heading: "", values: [""] },
      },
    }));
  };

  return (
    <div className="mb-4  border  rounded p-3">
      <label className="fs-5 text-light-gray mb-2">{label}</label>
      <Form.Control
        as="textarea"
        placeholder="Description"
        value={data.description || ""}
        onChange={(e) => handleChange("description", e.target.value)}
        className="mb-3 fs-5"
      />

      {Object.entries(data)
        .filter(([k]) => k !== "description")
        .map(([sectionKey, section]) => (
          <div
            key={sectionKey}
            className="p-3 border border-primary rounded mb-3"
          >
            <Row className="mb-2">
              <Col xs={10}>
                <Form.Control
                  type="text"
                  placeholder="Heading"
                  value={section.heading}
                  onChange={(e) =>
                    handleSectionChange(sectionKey, "heading", e.target.value)
                  }
                  className="fs-5"
                />
              </Col>
              <Col xs={2}>
                <Button
                  variant="outline-danger"
                  size="sm"
                  onClick={() => deleteSection(sectionKey)}
                  className="fs-6"
                >
                  Delete Section
                </Button>
              </Col>
            </Row>

            {section.values.map((val, idx) => (
              <Row key={idx} className="mb-2">
                <Col xs={10}>
                  <Form.Control
                    type="text"
                    placeholder="Value"
                    value={val}
                    onChange={(e) =>
                      handleValueChange(sectionKey, idx, e.target.value)
                    }
                    className="fs-5"
                  />
                </Col>
                <Col xs={2}>
                  <Button
                    variant="outline-danger"
                    size="sm"
                    onClick={() => deleteValue(sectionKey, idx)}
                    className="fs-6"
                  >
                    Delete Value
                  </Button>
                </Col>
              </Row>
            ))}

            <Button
              variant="outline-primary"
              size="md"
              onClick={() => addValue(sectionKey)}
            >
              + Add Value
            </Button>
          </div>
        ))}

      <Button variant="outline-success" size="md" onClick={addSection}>
        + Add Section
      </Button>
    </div>
  );
}
